export const TrainingMatrixFactory = () => {
    return function TrainingMatrix() {
        this.id = null;
        this.name = null;
        this.description = null;
        this.documents = [];
    };
};
